var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4F6EF7",
    fillRule: "nonzero",
    d: "M19.8412818,10 C19.8423262,13.754368 17.7571011,17.1930094 14.4417989,18.904 C14.1587302,19.0506667 13.8677249,19.184 13.5687831,19.304 C12.5967836,19.6913804 11.5698466,19.9204642 10.526455,19.9826667 C10.3271605,19.9942222 10.1252205,20 9.92063492,20 L9.66534392,20 C8.95174715,19.981916 8.24217083,19.886251 7.5489418,19.7146667 C7.11566174,19.6073521 6.69008566,19.470595 6.27513228,19.3053333 C5.97707231,19.1862222 5.68606702,19.0528889 5.4021164,18.9053333 C2.17514953,17.2026845 0.133292201,13.8544812 0.0831432452,10.1833706 C0.0329942896,6.51226007 1.982619,3.10865551 5.16185339,1.31708937 C8.34108778,-0.474476768 12.2386255,-0.365872509 15.3148148,1.6 C15.5793651,1.77777778 15.8381834,1.96533333 16.0912698,2.16266667 C18.4644482,4.05964013 19.8459797,6.94697962 19.8412818,10 Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    points: "13.784 7.728 9.311 12.795 6.509 10.547"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.cbe66c952dcc2339ec4943f71eca38a5.svg";
export { ForwardRef as ReactComponent };